import { combinationSteps } from "./combinationSteps";
import { disqualificationSteps } from "./disqualificationSteps";
import { hypertensionSteps } from "./hypertensionSteps";
import { landingPageSteps } from "./landingPageSteps";
import { obesitySteps } from "./obesitySteps";
import { sharedSteps } from "./sharedSteps";
import { Steps } from "./types";

export const onboardingGraph: Steps = {
  ...sharedSteps,
  ...hypertensionSteps,
  ...obesitySteps,
  ...combinationSteps,
  ...disqualificationSteps,
  ...landingPageSteps,
};
